const GAP = 4
const MARGIN = 8

export const getTmsCalendarPosition = (
  anchor: { top: number; bottom: number; left: number },
  popup: { width: number; height: number },
  viewport: { width: number; height: number },
) => {
  const below = anchor.bottom + GAP
  const above = anchor.top - popup.height - GAP
  const fitsBelow = below + popup.height <= viewport.height - MARGIN
  const fitsAbove = above >= MARGIN
  const moreSpaceAbove = anchor.top > viewport.height - anchor.bottom
  const top = fitsBelow
    ? below
    : fitsAbove || moreSpaceAbove
      ? above
      : below

  return {
    top: Math.max(MARGIN, Math.min(top, viewport.height - popup.height - MARGIN)),
    left: Math.max(
      MARGIN,
      Math.min(anchor.left, viewport.width - popup.width - MARGIN),
    ),
  }
}
